import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TargetCompanyService {
  private readonly storageKey = 'colorjob_company_id';
  private readonly cookieName = 'colorjob_company_id';

  getTargetCompanyId(explicitCompanyId?: string | number | null, returnUrl?: string | null): number | null {
    return this.parseCompanyId(explicitCompanyId)
      ?? this.extractCompanyIdFromUrl(returnUrl)
      ?? this.getStoredCompanyId();
  }

  setTargetCompanyId(companyId: number | string | null | undefined): void {
    const parsedCompanyId = this.parseCompanyId(companyId);
    if (!parsedCompanyId) return;

    localStorage.setItem(this.storageKey, String(parsedCompanyId));
    document.cookie = `${this.cookieName}=${parsedCompanyId}; path=/; max-age=31536000; SameSite=Lax`;
  }

  clearTargetCompanyId(): void {
    localStorage.removeItem(this.storageKey);
    document.cookie = `${this.cookieName}=; path=/; max-age=0; SameSite=Lax`;
  }

  extractCompanyIdFromUrl(url?: string | null): number | null {
    if (!url) return null;

    try {
      url = decodeURIComponent(url);
    } catch {
      return null;
    }

    const match = url.match(/(?:^|\/)company\/(\d+)(?:\/|$|\?)/i);
    return this.parseCompanyId(match?.[1]);
  }

  private getStoredCompanyId(): number | null {
    return this.parseCompanyId(localStorage.getItem(this.storageKey)) ?? this.parseCompanyId(this.getCookieValue());
  }

  private getCookieValue(): string | null {
    const cookie = document.cookie
      .split(';')
      .map((value) => value.trim())
      .find((value) => value.startsWith(`${this.cookieName}=`));

    return cookie?.substring(this.cookieName.length + 1) ?? null;
  }

  private parseCompanyId(value?: string | number | null): number | null {
    if (value === null || value === undefined || value === '') return null;
    const parsedValue = Number(value);
    return Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : null;
  }
}
